export enum TYPE_ORGANIZATION {
	IP = 'ip',
	OOO = 'ooo',
}

export enum ONLINE_IDENTIFICATION {
	ONLINE = 'true',
	OFFLINE = 'false',
}

export enum OPTIONS_CREATE_PARAMS {
	ORG_TYPE = 'org_type',
	ONLINE_IDENTIFICATION = 'online_identification',
}

export const SECONDS_LIMIT_CONFIRM = 186

export enum TYPE_AGREEMENT {
	SMS = 'sms',
	PAPER = 'paper',
}
